import {useForm} from "@inertiajs/vue3";
import FormRenderer from '@/pages/inspection_reports/forms/form_renderer.vue'

export default {
	components: {FormRenderer},

	data() {
		return {
			groups: {},
			loaded: {}
		}
	},

	async mounted() {
		this.groups = await new Promise((resolve) => {
			let groups = this.getGroups();
			resolve(groups);
		});
		this.$refs.renderer.setGroups(this.groups);
	},

	props: {
		customerProduct: {
			required: true,
			type: Object
		},
		inspectionReport: {
			required: true,
			type: Object
		},
		inspectionReportResponse: {
			required: false,
			type: Object
		},
		appointmentId: {
			required: true,
		},
	},

	methods: {
		input(settings) {
			let result =  Object.assign({
				type: 'Default',
				value: ''
			}, settings);
			if(typeof settings.value == 'undefined') {
				result.value = '';
			}
			return result;
		},

		getValue(name, defaultValue = '') {
			if(!this.inspectionReportResponse.values) {
				return defaultValue;
			}

			let result = this.inspectionReportResponse.values.filter((value) => value.name == name)[0] ?? null;
			let value = defaultValue;

			if(result) {
				value = result.value;
			}

			return value;
		},

		getOptionValue(name, defaultValue = '') {
			if(!this.inspectionReportResponse.values) {
				return defaultValue;
			}
			let result = this.inspectionReportResponse.values.filter((value) => value.name == name)[0] ?? null;
			let value = defaultValue;
			if(result) {
				value = result.option;
			}
			return value;
		},

		getGroups() {
			return {};
		},

		getCylinder(type) {
			return this.cylinders.filter((cylinder) => cylinder.type == type)[0] ?? {};
		},
	},

	computed: {
		softwareVersion() {
			return this.customerProduct.product.type.software_version ?? '';
		},

		checksum() {
			return this.customerProduct.product.type.checksum ?? '';
		},

		aanwijsinrichting() {
			return this.customerProduct.product.type.aanswijsinrichting ?? '';
		}
	}
}